import { Message } from "element-ui";
// 通用复制

export const copyInfo = value => {
  console.log(navigator.userAgent);
  // 获取需要复制的文字
  const copyStr = value;
  // 创建input标签存放需要复制的文字
  const oInput = document.createElement("input");
  // 把文字放进input中，供复制
  oInput.value = copyStr;
  document.body.appendChild(oInput);
  // 选中创建的input
  if (navigator.userAgent.match(/(iPhone|iPod|iPad|Safari);?/i)) {
    oInput.setSelectionRange(0, oInput.value.length);
    oInput.focus();
  } else {
    oInput.select();
  }

  // 执行复制方法， 该方法返回bool类型的结果，告诉我们是否复制成功
  const copyResult = document.execCommand("copy");
  // 操作中完成后 从Dom中删除创建的input;
  document.body.removeChild(oInput);
  // 根据返回的复制结果 给用户不同的提示
  if (copyResult) {
    Message.success("复制成功！");
  } else {
    Message.error("复制失败！");
    // Message({
    //   title: '复制失败！',
    //   type: 'error',
    //   duration: 2500
    // });
  }
};
